<template>
  <body :class="classes">
    <router-view />

    <div v-if="$store.state.modal.isShow" class="modal-base">
      <component :is="$store.state.modal.target" />
    </div>
  </body>
</template>

<script>
export default {
  name: "App",
  components: {
    ModalConnectWallet: () =>
      import("@/components/molecules/ModalConnectWallet"),
    AccountWalletModal: () =>
      import("@/components/organisms/account/AccountWalletModal"),
    GetTokenModal: () => import("@/components/molecules/GetTokenModal"),
    GetCakelpModal: () => import("@/components/molecules/GetCakelpModal"),
    MessageModal: () => import("@/components/molecules/MessageModal"),
    StakingHarvestModal: () =>
      import("@/components/organisms/staking/StakingHarvestModal"),
    StakeModal: () => import("@/components/molecules/StakeModal"),
    UnstakeModal: () => import("@/components/molecules/UnstakeModal"),
    CakelpFarmingHarvestModal: () =>
      import("@/components/organisms/cakelp-farming/CakelpFarmingHarvestModal"),
    CakelpFarmingStakeModal: () =>
      import("@/components/molecules/CakelpFarmingStakeModal"),
    CakelpFarmingUnstakeModal: () =>
      import("@/components/molecules/CakelpFarmingUnstakeModal"),
  },
  computed: {
    classes() {
      return [
        `theme--${this.$store.state.theme}`,
        { "is-modal": this.$store.state.modal.isShow },
      ];
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/style.scss";

.theme--light {
  @each $item in $colors-array {
    --#{$item}: #{map-get($light-theme, #{$item})};
  }
}

.theme--dark {
  @each $item in $colors-array {
    --#{$item}: #{map-get($dark-theme, #{$item})};
  }
}
body {
  background: var(--color_bg);
  color: var(--color_font);

  &.is-modal {
    overflow: hidden;
  }
}

.modal-base {
  z-index: 2;
  background: var(--color_bg_modal);
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
}
.vt-notification > .vt-icon-container > .vt-icon {
  width: 36px !important;
  height: 36px !important;
}
</style>